import { render, staticRenderFns } from "./SideCart.vue?vue&type=template&id=b687927c&scoped=true&"
import script from "./SideCart.vue?vue&type=script&lang=js&"
export * from "./SideCart.vue?vue&type=script&lang=js&"
import style0 from "./SideCart.vue?vue&type=style&index=0&id=b687927c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b687927c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\collection-gifting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b687927c')) {
      api.createRecord('b687927c', component.options)
    } else {
      api.reload('b687927c', component.options)
    }
    module.hot.accept("./SideCart.vue?vue&type=template&id=b687927c&scoped=true&", function () {
      api.rerender('b687927c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CollectionGifting/components/GOCPreview/Tier/SideCart.vue"
export default component.exports